<template>
    <div id="app">

        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <!--        <router-view style="overflow: hidden"/>-->

        <!-- 底部选择社区弹窗 -->
        <van-popup v-model="isShowPanel" round position="bottom" :safe-area-inset-bottom="true" :closeable="false"
                   :close-on-click-overlay="false">
            <div class="navigation-type">
                <van-picker
                    title=""
                    cancel-button-text="-"
                    show-toolbar
                    :columns="banshichuList"
                    @confirm="onConfirm"
                    @cancel="onCancel"
                    value-key="text"
                />
            </div>
        </van-popup>

        <float-button
            :itemHeight='80'
            :itemWidth='80'
            :gapWidthHide='180'
            :hideWidth='80'
            @onFloatBtnClicked="toChatBot"
        ></float-button>
    </div>
</template>

<script>
// CMD
import Cookies from 'js-cookie'
import {getCydnToken, GetRequest} from "@/utils";

import FloatButton from "@/views/components/FloatButton.vue";
import {Dialog} from "vant";

const RongIMLib = require('@rongcloud/imlib-next')

export default {
    components: {
        FloatButton,
    },
    data() {
        return {
            num: 0,
            notice: '',
            gobalToken: {},
            list: [],
            talk: [],
            dialogBan: false,
            dialogBanData: '',
            rongyun: null,
            messageList: [],

            userStatus: '',
            location: '', // 经纬度字符串
            isShowPanel: false, // 是否显示底部选择社区弹窗
            banshichuList: [
                //     {
                //     id: "1681196219074768898",
                //     parentId: 0,
                //     tenantId: "000001",
                //     tenantName: "经开区",
                //     text: "经开区",
                //     tenantPath: "000001",
                //     tenantType: 2,
                //     wisdomCode: "000001",
                //     children: [],
                // }
            ],
            isGetLocation: false, // 是否获取到定位

            isAlreadyForceShow: false, // 是否已经强制显示过
        }
    },
    created() {
        // -------------------------
        // selectCommunityName: '', // 手动选择的社区 1 （用于搭配办事处展示在首页）
        // selectBanshichuName: '', // 手动选择的办事处 1 （用于特色功能 判断）
        // selectCommunityCode: '', // 手动选择的社区code 1 （switch传值）
        // selectBanshichuCode: '', // 手动选择的办事处code 1
        // userCommunityName: '', // 用户信息里的社区 2 （用于搭配办事处展示在首页）
        // userBanshichuName: '', // 用户信息里的办事处 2 （用于特色功能 判断）
        // userCommunityCode: '', // 用户信息里的社区code 2 （witch传值）
        // userBanshichuCode: '', // 用户信息里的办事处code 2
        // currentBanshichuName: '', // 反算或用户信息里的办事处名称 3 （用于搭配社区展示在首页 和 判断特色功能 游客身份或未认证居民）
        // currentBanshichuCode: '', // 反算或用户信息里的办事处code 3
        // currentCommunityName: '', // 反算或用户信息里的社区名称 3 （用于搭配办事处展示在首页 游客身份或未认证居民）
        // currentCommunityCode: '', // 反算或用户信息里的社区code 3  （用于switch传值）
        // tenantId: '', // 反算或用户信息里的租户id 3
        // -------------------------

        // 获取用户信息
        let url = window.location.href
        console.log(url)
        localStorage.setItem('auth_url', url)
        this.params = GetRequest(url)
        console.log(this.params, 'params')
        // alert(JSON.stringify(this.params))
        if (this.params.homeRedirct && this.params.homeRedirct == '/home-yatai') {
            this.$store.state.location.homeRedirct = this.params.homeRedirct
            this.$store.state.location.selectCommunityCode = '410171001'
            this.$store.state.location.fullAddress = '明湖办事处'
            this.$store.state.location.tenantId = '782062'
            this.$router.replace('/')
        } else if (this.params.homeRedirct && this.params.homeRedirct.indexOf('410171003') != -1) {
            this.$store.state.location.homeRedirct = '/home'
            this.$store.state.location.selectCommunityCode = '410171003'
            this.$store.state.location.fullAddress = '京航办事处'
            this.$store.state.location.tenantId = '688252'
            this.$router.replace('/')
        } else if (this.params.homeRedirct && this.params.homeRedirct.indexOf('410171002') != -1) {
            this.$store.state.location.homeRedirct = '/home'
            this.$store.state.location.selectCommunityCode = '410171002'
            this.$store.state.location.fullAddress = '潮河办事处'
            this.$store.state.location.tenantId = '134359'
            this.$router.replace('/')
        }

        // todo 测试用 正式注释
        // Cookies.set('jk_community_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJpc3N1ZXIiLCJhdWQiOiJhdWRpZW5jZSIsImNsaWVudFR5cGUiOiJhcHAtcmVzaWRlbnQiLCJ0ZW5hbnRJZCI6IjU3NTg5OSIsInVzZXJJZCI6IjE4NTM2ODE5OTg1MjYwNTQ0MDEiLCJ0ZW5hbnRQYXRoIjoiMTM0MzU5LTU3NTg5OSIsImV4cCI6MTc1Mjc1NzA4NSwibmJmIjoxNzUyNzEzODg1fQ.T75ProN0S35309vafrdmP3xU8zhuZQHxkNc4ynthtJvEPwSdAE4PHsBDofa4tlEF9vaTdh7BB1t-_OCo-lPQFw')
        if (this.params.token && Cookies.get('jk_community_token') != this.params.token) {
            Cookies.set('jk_community_token', this.params.token)

            // localStorage.clear()
            localStorage.removeItem("userInfo");
        }
        // this.getUserInfo()
        if (!this.params.token) {
            localStorage.setItem("userInfo", '');
            localStorage.removeItem("userInfo");
            // Cookies.set('jk_community_token', '')
            // Cookies.remove('jk_community_token')
        } else {
            // this.getUserInfo()
        }
        this.getUserInfo()

        this.userStatus = this.params.status
        // Cookies.set('user_status', this.params.status)
        // if (this.userStatus == 'community') {
        //     Cookies.set("X-Client-Type", 'app-community');
        // } else {
        //     Cookies.set("X-Client-Type", 'app-resident');
        // }

        // if (this.params.location) {
        //     this.isGetLocation = true
        // }
        // this.location = this.params.location
        // todo 测试用 正式换
        // Cookies.set('location', '113.74,34.73')
        Cookies.set('location', this.params.location)
        localStorage.setItem('lngLatStr', this.params.location)

        // 判断是否已经有tenentId,有的话切换token
        if (Cookies.get('jk_community_token')) {
        // if (this.$store.state.location.tenantId) {
            this.switchToken()
        }

        //getEnv获取环境
        // wx.miniProgram.getEnv(function (res) {
        //
        //     if (res.miniprogram) {
        //         //如果当前是小程序环境
        //         wx.miniProgram.postMessage({
        //             data: {
        //                 name: 'name',
        //                 age: 12
        //             }
        //         })
        //     }
        // })

        if (this.params.nvaiUrl) {
          if(this.params.id){
            this.$router.push({path: this.params.nvaiUrl+'?id='+this.params.id})
          }
        }
    },
    mounted() {
        // 产业大脑token
        getCydnToken()

        console.log("===>", window.location.hash);
        window.addEventListener(
            "hashchange",
            (e) => {
                console.log(e)
                var currentPath = window.location.hash.slice(1); // 获取输入的路由

                if (this.$router.path !== currentPath) {
                    //  this.$router.push(currentPath); // 动态跳转
                    if (localStorage.getItem("code")) {
                        this.$router.push({
                            path: currentPath.split("?")[0],
                            query: {code: localStorage.getItem("code").split("=")[1]},
                        }); // 动态跳转
                    }
                }
            },
            false
        );

        // if (this.location) {
        //     this.getRegeo(this.location)
        // } else {
        //     this.getLocation()
        // }

        // 应用初始化以获取 RongIMLib 实例对象，请务必保证此过程只被执行一次
        // RongIMLib.init({appkey: 'pvxdm17jpfwtr'});
        // this.getIMToken()

        if (Cookies.get('X-Client-Type') == 'app-community') {
            // 社区账号 可以通过它跳转默认社区的页面
            // this.$router.push({path: "/blank-view"})
        }

    },
    methods: {
        toChatBot() { // 点击组件调用的方法
          jWeixin.miniProgram.navigateTo({url: '/pages/web/web?url=' + 'https://jk.zzijk.com/nextapp'})
          // jWeixin.miniProgram.navigateTo({url: '/pages/kefu/kefu'})
          // jWeixin.miniProgram.navigateTo({url: '/pages/web/web?url=' + 'https://www.haoyukongjian.cn:10081/chatbot/roeF9XKT1pYihiuz'})
          //   jWeixin.miniProgram.navigateTo({url: '/pages/chat/chat'})
        },
        // 获取社区列表
        getCommunityList() {
            this.$http.get('/sys/tenant/banshichu').then(({data: res}) => {
                // this.$http.get('/sys/tenant/community').then(({data: res}) => {
                if (res.code == 0) {

                    let newArr = res.data
                    newArr.forEach(item => {
                        if (item.tenantName == '经开区') {
                            // item.tenantName = '全区';
                            item.wisdomCode = "000001"
                        }
                    })
                    // 只保留包含 经开 京航 明湖 的办事处
                    newArr = newArr.filter(item => {
                        return item.tenantName.includes('经开') || item.tenantName.includes('京航') || item.tenantName.includes('明湖')
                    })
                    console.log(newArr, 'newArr')
                    this.banshichuList = newArr
                    console.log(this.banshichuList, '==...')
                    this.changeKey(this.banshichuList, 'tenantName', 'text')

                    this.isShowPanel = true
                }
            })
        },
        // 更换多级数组中的字段名
        changeKey(arr, key, value) {
            arr.forEach(item => {
                item[value] = item[key]

                if (item.children && item.children.length > 0) {
                    this.changeKey(item.children, key, value)
                } else {
                    delete item.children
                }
            })
        },
        selectCommunity() {
            this.isShowPanel = true
        },
        onConfirm(value, index) {

            // console.log(`当前值：${value}, 当前索引：${index}`);
            this.communityCode = this.banshichuList[`${index}`].wisdomCode
            this.fullAddress = this.banshichuList[`${index}`].tenantName
            this.banshichuCode = this.banshichuList[`${index}`].wisdomCode

            this.$store.state.location.selectBanshichuName = this.banshichuList[`${index}`].tenantName // selectBanshichu 级别最高，有值忽略其他
            this.$store.state.location.selectCommunityName = this.banshichuList[`${index}`].tenantName // selectBanshichu 级别最高，有值忽略其他
            this.$store.state.location.selectBanshichuCode = this.banshichuList[`${index}`].wisdomCode // selectBanshichu 级别最高，有值忽略其他
            this.$store.state.location.selectCommunityCode = this.banshichuList[`${index}`].wisdomCode // selectBanshichu 级别最高，有值忽略其他
            this.$store.state.location.fullAddress = this.banshichuList[`${index}`].tenantName.replace('街道', '办事处') // selectBanshichu 级别最高，有值忽略其他
            this.$store.state.location.tenantId = this.banshichuList[`${index}`].tenantId // selectBanshichu 级别最高，有值忽略其他

            if (this.$store.state.location.selectCommunityCode.indexOf('410171001') != -1) {
                this.$store.state.location.homeRedirct = '/home-yatai'
                jWeixin.miniProgram.navigateTo({url: '/pages/home/home'})
                this.isShowPanel = false
                return
            }

            // localStorage.setItem('selectBanshichuName', this.banshichuList[`${index}`].tenantName) // selectBanshichu 级别最高，有值忽略其他
            // localStorage.setItem('selectCommunityName', this.banshichuList[`${index}`].tenantName)
            // localStorage.setItem('selectBanshichuCode', this.banshichuList[`${index}`].wisdomCode)
            // localStorage.setItem('selectCommunityCode', this.banshichuList[`${index}`].wisdomCode)
            // localStorage.setItem('fullAddress', this.banshichuList[`${index}`].tenantName.replace('街道', '办事处'))
            // localStorage.setItem('tenantId', this.banshichuList[`${index}`].tenantId)
            //
            // if (localStorage.getItem('selectCommunityCode').indexOf('410171001') != -1) {
            //     // if (localStorage.getItem('selectCommunityCode') == '410171001002') {
            //     this.isShowPanel = false
            //     localStorage.setItem('home-redirct', '/home-yatai')
            //     jWeixin.miniProgram.redirectTo({url: '/pages/home/home'})
            //     return
            // }

            this.isShowPanel = false
            // 刷新网页
            window.location.reload()
        },
        onCancel() {
        },
        // 获取用户信息
        getUserInfo() {
            if(!Cookies.get('jk_community_token')){
              if (!Cookies.get("X-Client-Type")) {
                Cookies.set("X-Client-Type", 'app-resident');
              }
              if (!this.$store.state.location.tenantId || !this.$store.state.location.fullAddress) {
                this.$store.state.location.selectBanshichuName = '经开区'
                this.$store.state.location.selectBanshichuCode = ''
                this.$store.state.location.fullAddress = '经开区'
                this.$store.state.location.tenantId = '000001'
              }
              return
            }
            this.$http.get("/sys/user/info").then(({
                                                       data: res
                                                   }) => {
                console.log(res);
                if (res.code == 0) {
                    // 设置过就不再 在初始化的时候 重新设置
                    if (!Cookies.get("X-Client-Type")) {
                        // 因为现在改成了，默认进入居民端，所以这里直接设置居民端
                        Cookies.set("X-Client-Type", 'app-resident');
                        // if (res.data.communityStatus == '1') {
                        //     Cookies.set("X-Client-Type", 'app-community');
                        // } else {
                        //     Cookies.set("X-Client-Type", 'app-resident');
                        // }
                    }

                    res.data.avatar = res.data.headUrl ? res.data.headUrl : require('@/assets/avatar_default.jpg')

                    this.$store.state.user.userInfo = res.data
                    localStorage.setItem("userInfo", JSON.stringify(res.data));
                    // 去掉所有userbanshichuname信息，改成默认经开区
                    if (!this.$store.state.location.tenantId || !this.$store.state.location.fullAddress) {
                        this.$store.state.location.selectBanshichuName = '经开区'
                        this.$store.state.location.selectBanshichuCode = ''
                        this.$store.state.location.fullAddress = '经开区'
                        this.$store.state.location.tenantId = '000001'
                    }

                    // 如果用户有所属社区保存社区名称
                    // if (res.data.banshichuName) {
                    //     localStorage.setItem('userBanshichuName', res.data.banshichuName)
                    //     localStorage.setItem('userBanshichuCode', res.data.banshichuCode)
                    //     localStorage.setItem('userCommunityName', res.data.communityName)
                    //     localStorage.setItem('userCommunityCode', res.data.communityCode)
                    //     if (!localStorage.getItem('selectCommunityCode')) {
                    //         // 如果用户没有选择社区，保存用户信息的社区名称
                    //         localStorage.setItem('fullAddress', res.data.banshichuName.replace('街道', '办事处'))
                    //         this.$store.state.user.userInfo.fullAddress = res.data.banshichuName.replace('街道', '办事处')
                    //     }
                    // }
                    // // tennantId 始终存在，应该独立出来
                    // if (res.data.tenantId) {
                    //     // 说明已认证 banshichuName存在
                    //     if (!localStorage.getItem('selectCommunityCode')) {
                    //         // 如果用户没有选择社区，保存用户信息的社区名称
                    //         localStorage.setItem('tenantId', res.data.tenantId)
                    //         this.switchToken()
                    //     }
                    // } else {
                    //     if (!localStorage.getItem('selectCommunityCode')) {
                    //         // 不存在tenantId且没有手选位置
                    //         // 这时候应该尝试定位
                    //         // 根据定位判断所属社区
                    //         if (this.location) {
                    //             this.getRegeo(this.location)
                    //         } else {
                    //             this.getLocation()
                    //         }
                    //     }
                    // }

                } else {
                    this.$toast(res.msg);
                }
            }).catch((err)=>{
              Dialog.confirm({
                title: '提示',
                message: '登录信息过期，请重新登录',
              }).then(() => {
                // on close
                jWeixin.miniProgram.navigateTo({url: '/pages/home/home'})
              }).catch(()=>{
                if (!Cookies.get("X-Client-Type")) {
                  // 因为现在改成了，默认进入居民端，所以这里直接设置居民端
                  Cookies.set("X-Client-Type", 'app-resident');
                  // if (res.data.communityStatus == '1') {
                  //     Cookies.set("X-Client-Type", 'app-community');
                  // } else {
                  //     Cookies.set("X-Client-Type", 'app-resident');
                  // }
                }

              });
            });
        },
        switchToken() {
            let code = ''
            if (this.$store.state.location.tenantId) { // 正常情况下tenantId始终存在
                // if (localStorage.getItem('tenantId')) { // 正常情况下tenantId始终存在
                code = this.$store.state.location.tenantId
                // code = localStorage.getItem('tenantId')
            } else {
                code = ''
            }
            this.$http.get("switch-client?tenantId=" + code, {loading: true})
                .then(({data: res}) => {
                    if (res.code == '0') {
                        Cookies.set('jk_community_token', res.data.token)
                    } else {
                        this.$toast(res.msg)
                    }
                })
                .catch(err => {
                    this.$toast(err.msg)
                })
        },
        // 获取定位
        getLocation() {
            let _this = this
            this.loadingGeo = true
            // let p=[113.480999,34.812921]
            // console.log(window.AMap.GeometryUtil.distance(p, ['113.482132','34.813934']));
            window.AMap.plugin('AMap.Geolocation', function () {
                let geolocation = new window.AMap.Geolocation({
                    // 是否使用高精度定位，默认：true
                    enableHighAccuracy: true,
                    // 设置定位超时时间，默认：无穷大
                    timeout: 10000,
                    // 定位按钮的停靠位置的偏移量
                    offset: [10, 20],
                    //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    zoomToAccuracy: true,
                    //  定位按钮的排放位置,  RB表示右下
                    position: 'RB'
                })
                geolocation.getCurrentPosition(function (status, result) {
                    // alert(JSON.stringify(result))
                    if (status == 'complete') {
                        // // 高德api计算距离
                        let lngLatStr = result.position.lng + ',' + result.position.lat
                        localStorage.setItem('lngLatStr', lngLatStr)
                        this.location = lngLatStr
                        if (this.location) {
                            this.isGetLocation = true
                        }

                        _this.getRegeo(lngLatStr)

                    } else {
                        _this.loadingGeo = false;
                        // 没有传定位 h5也获取不到位置
                        // 强制弹窗
                        this.getCommunityList()
                        // this.isShowPanel = true
                        // _this.$toast('获取当前定位失败,请检查GPS开关是否开启')
                    }
                });
            })
        },
        // 经纬度反算位置
        getRegeo(location) {
            let lng = ''
            let lat = ''
            if (location) {
                lng = location.split(',')[0]
                lat = location.split(',')[1]
            }
            // 根据接口反算位置
            this.$http.get("/wisdom/location" + "?longitude=" + lng + '&latitude=' + lat).then(({
                                                                                                    data: res
                                                                                                }) => {
                if (res.code == 0) {
                    // 如果不在经开区，则返回位置为null
                    // "tenantId": "087221",
                    //     "communityName": "远大社区",
                    //     "banshichuCode": "410171001",
                    //     "tenantPath": "782062-087221",
                    //     "communityCode": "410171001004",
                    //     "banshichuName": "明湖街道"
                    if (res.data) {
                        localStorage.setItem('currentBanshichuName', res.data.banshichuName)
                        localStorage.setItem('currentCommunityName', res.data.communityName)
                        localStorage.setItem('currentBanshichuCode', res.data.banshichuCode)
                        localStorage.setItem('currentCommunityCode', res.data.communityCode)
                        // 如果没有手动选，用户信息里也没有，才会使用定位的社区
                        if (!localStorage.getItem('selectCommunityCode') && !localStorage.getItem('userCommunityCode')) { // 只有当用户信息的接口拿不到时，才使用反算的办事处name
                            localStorage.setItem('fullAddress', res.data.banshichuName.replace('街道', '办事处'))
                            localStorage.setItem('tenantId', res.data.tenantId)
                        }
                        if(this.$store.state.location.tenantId){
                          if (Cookies.get('jk_community_token')) {
                            // if (this.$store.state.location.tenantId) {
                            this.switchToken()
                          }
                        }
                    } else {
                        if (!localStorage.getItem('selectCommunityCode') && !localStorage.getItem('userCommunityCode')) { // 只有当用户信息的接口拿不到时，才使用反算的办事处name
                            localStorage.setItem('fullAddress', '')

                            // 没有手选，身份里也没有，经纬度给没给都拿不到社区的情况下，强制弹窗
                            setTimeout(() => {
                                this.getCommunityList()
                                // this.isShowPanel = true

                                // if (!this.isAlreadyForceShow){
                                //     this.getCommunityList()
                                //     this.isShowPanel = true
                                //     // 防止多次强制弹窗
                                //     this.isAlreadyForceShow = true
                                // }
                            }, 500)
                        }
                    }
                } else {
                    this.$toast(res.msg);
                }
            });

            // const mapKey = "481a287610b5a33f1e51507c771986da"; //key 秘钥
            // axios
            //     .get("https://restapi.amap.com/v3/geocode/regeo", {
            //         params: {
            //             key: mapKey,
            //             location,
            //         },
            //     })
            //     .then((res) => {
            //         // console.log(res);
            //         if (res.data.status == "1") {
            //             // alert(res.data.regeocode.formatted_address)
            //             this.addressKey = res.data.regeocode.formatted_address.split('河南省郑州市')[1].split('区')[0] + '区';
            //             localStorage.setItem('addressKey', this.addressKey)
            //             let beforeStr=res.data.regeocode.formatted_address.split('河南省郑州市')[1]
            //             let afterStr =''
            //             if (beforeStr){
            //                afterStr= beforeStr.slice(beforeStr.indexOf('区') + 1);
            //             }else{
            //                 let beforeStr2= res.data.regeocode.formatted_address
            //                 afterStr = beforeStr2.slice(beforeStr2.indexOf('区') + 1);
            //             }
            //
            //             localStorage.setItem('fullAddress', afterStr)
            //         }
            //     })
            //     .catch((e) => {
            //         // alert(e)
            //     });
        },
        // 获取token
        getIMToken() {
            if (localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).rongyunToken) {
                console.log('linkerongyun')
                this.linkToRongs(JSON.parse(localStorage.getItem('userInfo')).rongyunToken)
            }

            // getIMToken().then(res => {
            //   var time = new Date().getTime()
            //   res.time = time
            //   // 将token保存下来
            //   this.gobalToken = res
            //   var tokenStr = JSON.stringify(res)
            //   localStorage.setItem('token', tokenStr)
            //   // 初始化融云
            //   this.linkToRongs(res.data)
            // })
        },
        // 判断token是否过期
        isToken() {
            var now = new Date().getTime()
            // 获取上一次存储的token
            var oldToken = JSON.parse(localStorage.getItem('token'))
            // 判断之前获取的token
            if (oldToken) {
                var tokenTime = oldToken.time
                // 判断时间是否过期了
                if (now - tokenTime > 29 * 24 * 60 * 60 * 1000) {
                    this.getIMToken()
                } else {
                    this.gobalToken = JSON.parse(localStorage.getItem('token'))
                    this.linkToRongs(this.gobalToken.data)
                    return
                }
            }
            this.getIMToken()
        },
        // 链接融云
        linkToRongs(token) {
            const that = this
            // 初始化融云
            // 测试服 key:
            // 正式服 key:
            let RongClientKey = 'pvxdm17jpfwtr'
            // if (process.env.VUE_APP_BASE_API2 === '') {//测试服
            //   RongClientKey = 'pvxdm17jpfwtr'
            // } else {//正式服
            //   RongClientKey = 'pvxdm17jpfwtr'
            // }
            // 应用初始化以获取 RongIMLib 实例对象，请务必保证此过程只被执行一次
            // eslint-disable-next-line no-undef
            console.log(RongIMLib, RongClientKey)
            RongIMLib.init({appkey: RongClientKey})
            // 添加事件监听
            const Events = RongIMLib.Events

            RongIMLib.addEventListener(Events.CONNECTING, () => {
                console.log('正在链接服务器')
            })

            RongIMLib.addEventListener(Events.CONNECTED, () => {
                console.log('已经链接到服务器')
            })

            RongIMLib.addEventListener(Events.MESSAGES, (evt) => {
                console.log(evt.messages, '收到消息')
                if (evt.messages && evt.messages.length > 0) {
                    // 暂时只添加文本消息
                    if (evt.messages[0].messageType == 'RC:TxtMsg') {
                        this.$store.commit('setMessageNum', parseInt(this.$store.state.message.messageNum) + 1)
                    }
                }
                // if (evt.messages && evt.messages.length > 0) {
                //   this.$router.push({name: 'chat-view', params: {id: evt.messages[0].targetId}});
                // }
            })

            RongIMLib.connect(token).then(res => {
                if (res.code === RongIMLib.ErrorCode.SUCCESS) {
                    console.log('链接成功, 链接用户 id 为: ', res.data.userId);
                } else {
                    console.warn('链接失败, code:', res.code)
                }
            })
        },
    },
};
</script>

<style lang="scss">
#app {
    color: #222222;
    font-size: 28px;

    //padding-bottom: constant(safe-area-inset-bottom);
    //padding-bottom: env(safe-area-inset-bottom);

    overflow: hidden;
}

h2,
h3,
p {
    margin: 0;
    padding: 0;
}

ul,
li {
    margin: 0;
    padding: 0;
    list-style: none;
}

.icon-svg {
    width: 1em;
    height: 1em;
    fill: currentColor;
    vertical-align: middle;
    overflow: hidden;
}

// 基础样式
:root {
    box-sizing: border-box;
    --main-color: #148eff;
    --main-text-black-color: #222222;
    --main-text-gray-color: #AEB5BC;
}

*,
*::before,
*::after {
    box-sizing: inherit;
}

// 确认弹框
.confirm-van-popup {
    width: 86%;
    height: 282px;
    border-radius: 16px;
    padding: 50px 40px 40px;
    box-sizing: border-box;
}

.confirm-popup {
    > p {
        font-size: 32px;
        font-weight: 500;
        margin-bottom: 81px;
    }

    > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        > span {
            display: block;
            color: #666666;
            width: 180px;
            height: 64px;
            line-height: 64px;
            text-align: center;

            &:nth-child(2) {
                color: #fff;
                background: linear-gradient(90deg, #406ffd 0%, #5890ff 100%);
                box-shadow: 0 10px 20px 0 rgba(64, 111, 253, 0.2);
                border-radius: 8px;
            }
        }
    }
}
</style>
